import React, { ReactElement, useEffect, useState } from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import {
  defaultLayoutPlugin,
  ToolbarProps,
} from "@react-pdf-viewer/default-layout";
import { toolbarPlugin, ToolbarSlot } from "@react-pdf-viewer/toolbar";
import { thumbnailPlugin } from "@react-pdf-viewer/thumbnail";
import { getFilePlugin, RenderDownloadProps } from "@react-pdf-viewer/get-file";
import { RenderPrintProps } from "@react-pdf-viewer/print";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import "@react-pdf-viewer/thumbnail/lib/styles/index.css";
import "@react-pdf-viewer/page-navigation/lib/styles/index.css";
import "@react-pdf-viewer/print/lib/styles/index.css";
import { ExpandOutline } from "../Icons";
import axios from "axios";

interface PdfViewerProps {
  fileUrl: string;
  thumbnails?: boolean;
  PdfViewerPrintPlugin?: RenderPrintProps | any | undefined;
  PdfViewerDownloadPlugin?: RenderDownloadProps | any | undefined;
}

const PdfViewer: React.FC<PdfViewerProps> = ({
  fileUrl,
  thumbnails = true,
  PdfViewerPrintPlugin,
  PdfViewerDownloadPlugin,
}) => {
  const [thumbWidth, setThumbWidth] = useState(100);
  const thumbnailPluginInstance = thumbnailPlugin({
    thumbnailWidth: thumbWidth,
  });
  const { Thumbnails } = thumbnailPluginInstance;
  const toolbarPluginInstance = toolbarPlugin();

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    sidebarTabs: (defaultTabs) => [defaultTabs[0]],
    renderToolbar: (Toolbar: (props: ToolbarProps) => ReactElement) => (
      <Toolbar />
    ),
  });

  const { toggleTab } = defaultLayoutPluginInstance;
  toggleTab(0);
  const [url, seturl] = useState<string | null>(null);
  const [reRender, setreRender] = useState<boolean>(false);
  useEffect(() => {
    axios
      .get("https://corsproxy.io/?" + fileUrl)
      .then((res) => {
        seturl("https://corsproxy.io/?" + fileUrl);
      })
      .catch((err) => {
        setreRender(true);
      });
  }, [reRender]);

  const { Toolbar } = toolbarPluginInstance;
  const getFilePluginInstance = getFilePlugin(fileUrl as any);

  return (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
      <div
        className=" border border-solid border-gray-200 rounded-lg"
        style={{
          display: "flex",
          height: "100%",
          position: "relative",
        }}
      >
        <div
          className={` ${
            thumbnails ? `w-2/3` : `w-2/4`
          } flex items-center border border-solid border-gray-2 bg-white p-2 pr-2 pl-2 absolute z-10 top-1 rounded-lg`}
          style={{
            left: `${thumbnails ? `63%` : `50%`}`,
            transform: "translate(-50%, 0)",
          }}
        >
          <Toolbar>
            {(slots: ToolbarSlot) => {
              const {
                EnterFullScreen,
                CurrentPageLabel,
                CurrentScale,
                NumberOfPages,
                ZoomIn,
                ZoomOut,
              } = slots;
              return (
                <div className="flex items-center w-full bg-white gap-2 m-auto rounded-lg justify-between">
                  <div className="flex">
                    <div className="flex content-end items-center">
                      <EnterFullScreen>
                        {(props) => (
                          <>
                            <div onClick={props.onClick}>
                              <ExpandOutline />
                            </div>
                          </>
                        )}
                      </EnterFullScreen>
                    </div>
                  </div>
                  <div className="flex items-center content-start gap-2">
                    <div className=" w-px h-7 bg-gray-200"></div>
                    <div>
                      <ZoomOut>
                        {(props) => (
                          <h1
                            className=" text-gray-900 font-semibold"
                            onClick={props.onClick}
                          >
                            -
                          </h1>
                        )}
                      </ZoomOut>
                    </div>
                    <div className=" content-center w-10 items-center text-center inline-flex pt-1 pb-1 pl-3 pr-3 flex-col gap-2.5 bg-gray-200 rounded-lg">
                      <CurrentScale>
                        {(props) => (
                          <span>{`${Math.round(props.scale * 100)}%`}</span>
                        )}
                      </CurrentScale>
                    </div>
                    <div>
                      <ZoomIn>
                        {(props) => (
                          <h1
                            className=" text-gray-900 font-semibold"
                            onClick={props.onClick}
                          >
                            +
                          </h1>
                        )}
                      </ZoomIn>
                    </div>
                    <div className=" w-px h-7 bg-gray-200"></div>
                    <div className="mr-4">
                      <NumberOfPages /> /
                    </div>
                    <div className=" content-center items-center text-center w-4 inline-flex pt-1 pb-1 pl-3 pr-3 flex-col gap-2.5 bg-gray-200 rounded-lg">
                      <CurrentPageLabel />
                    </div>
                  </div>
                </div>
              );
            }}
          </Toolbar>
        </div>
        <div
          className="flex w-full rounded-lg"
          style={{
            overflow: "hidden",
          }}
        >
          <div
            className={`flex-1 overflow-hidden bg-primary-400 ${
              thumbnails ? `w-3/4` : `w-full`
            }`}
            style={{
              flex: 1,
              overflow: "hidden",
            }}
          >
            {url && (
              <Viewer
                fileUrl={url as any}
                plugins={[
                  PdfViewerPrintPlugin,
                  PdfViewerDownloadPlugin,
                  toolbarPluginInstance,
                  thumbnailPluginInstance,
                  getFilePluginInstance,
                ]}
              />
            )}
          </div>
          {thumbnails && (
            <div className={` w-1/4 flex flex-col bg-gray-600`}>
              <Thumbnails></Thumbnails>
            </div>
          )}
        </div>
      </div>
    </Worker>
  );
};

export default PdfViewer;
